import { Menu } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Children, cloneElement, isValidElement, ReactElement, ReactNode } from "react";
import { useMenuStyles } from "./use-menu-styles";

interface GoMakeMenuProps {
  handleClose: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
  children: ReactNode;
  style?: React.CSSProperties;
  sx?: object;
  noListPadding?: boolean;
  menuOffsetY?: number | string;
  PaperProps?: { sx?: object; [key: string]: unknown };
}

const GoMakeMenu = ({
  handleClose,
  open,
  anchorEl,
  children,
  style,
  sx,
  noListPadding = false,
  menuOffsetY,
  PaperProps: paperProps,
}: GoMakeMenuProps) => {
  const { t } = useTranslation();
  const direction = t("direction");
  const { paperProps: themePaperProps } = useMenuStyles();

  const paperSx =
    paperProps?.sx && typeof paperProps.sx === "object"
      ? paperProps.sx
      : paperProps &&
        typeof paperProps === "object" &&
        paperProps !== null &&
        !("sx" in paperProps)
      ? paperProps
      : {};
  const themeSx = themePaperProps?.sx ?? {};
  const resolvedPaperProps = {
    ...paperProps,
    sx: {
      ...themeSx,
      ...paperSx,
      ...(menuOffsetY !== undefined && { mt: menuOffsetY }),
    },
  };

  return (
    <Menu
      anchorReference="anchorEl"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={
        direction === "rtl"
          ? { vertical: "bottom", horizontal: "left" }
          : { vertical: "bottom", horizontal: "right" }
      }
      transformOrigin={
        direction === "rtl"
          ? { vertical: "top", horizontal: "left" }
          : { vertical: "top", horizontal: "right" }
      }
      style={style}
      sx={sx}
      {...(noListPadding && {
        MenuListProps: {
          sx: {
            padding: 0,
          },
        },
      })}
      PaperProps={resolvedPaperProps}
    >
      {Children.map(children, (child) =>
        isValidElement(child)
          ? cloneElement(child as ReactElement, {
              onKeyDown: (event: React.KeyboardEvent) => {
                event.stopPropagation();
              },
            })
          : null
      )}
    </Menu>
  );
};

export { GoMakeMenu };
